export enum CheckboxValueType {
	Yes = 'Yes',
	Off = 'Off',
}

/**
 * This map is used to determine the allowed values for a checkbox field.
 * The key represents the value of the checkbox field (the value that is stored in the database).
 * The value is an array of allowed values for the checkbox field (in any letter case).
 *
 * On: checked
 * Off: unchecked
 */
export const CheckboxAllowdValueTypesMap = {
	[CheckboxValueType.Yes]: ['On', 'Yes', 'True', '1', true],
	[CheckboxValueType.Off]: ['Off', 'No', 'False', '0', '', false],
} as const;

/**
 * @description This function is used to get the checkbox value from the given value.
 * @param value
 * @returns CheckboxValueType
 */
export function getCheckboxValue(value: unknown): CheckboxValueType {
	if (!value) return CheckboxValueType.Off;
	return Object.keys(CheckboxAllowdValueTypesMap).find(key =>
		CheckboxAllowdValueTypesMap[key].some((v: string | boolean) => v.toString().toLowerCase() === value.toString().toLowerCase()),
	) as CheckboxValueType;
}
